import { Component, OnInit, Input } from "@angular/core";
import { ICheckboxSettings } from "../../inputs/checkbox/checkbox.model";
import { IRadioButtonSettings } from "../../inputs/radio-button/radio-button.model";

@Component({
    selector: "dodo-form-elements",
    templateUrl: "./form-elements.component.html",
    styleUrls: ["./form-elements.component.scss"],
    standalone: false
})
export class FormElementsComponent implements OnInit {
	@Input() settings;

	demoElementsSettings = {
		checkBox: <ICheckboxSettings>{
			label: {
				text: {
					// default: "test label",
					on: "checked",
					off: "not chedked"
				}
			},
			layout: "default"
		},
		checkBoxLabelLeft: <ICheckboxSettings>{
			label: {
				text: {
					default: "test label"
				},
				position: "before"
			},
			layout: "default"
		},
		slideToggleWithLabel: <ICheckboxSettings>{
			label: {
				text: { off: "Click", on: "Clicked" }
			},
			layout: "slide"
		},
		slideToggleWithLabelBefore: <ICheckboxSettings>{
			label: {
				text: { off: "Click", on: "Clicked" },
				position: "before"
			},
			layout: "slide"
		},
		slideToggleWithNoLabel: <ICheckboxSettings>{
			layout: "slide"
		},
		radioButton: <IRadioButtonSettings>{
			radiobuttons: ["Radio One", "Radio Two"]
		}
	};

	constructor() {}

	ngOnInit() {}
}
